import { render } from "./AlertItemClustered.vue?vue&type=template&id=042a964a&scoped=true"
import script from "./AlertItemClustered.vue?vue&type=script&lang=js"
export * from "./AlertItemClustered.vue?vue&type=script&lang=js"

import "./AlertItemClustered.vue?vue&type=style&index=0&id=042a964a&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-042a964a"]])

export default __exports__